import { z } from 'zod';
import { defineEndpoint } from '../define';
import { DeviceFileGroupSchema } from '../device-file-groups';
import { DeviceFileSchema } from '../device-files';
import { DeviceRowSchema } from './shapes';

// Self-service read: the caller's assigned devices. Auth-only — no permission
// key, so users without devices:list can still manage what they hold.
export const MyDeviceSchema = DeviceRowSchema.extend({
  files: z.array(DeviceFileSchema),
});
export type MyDevice = z.infer<typeof MyDeviceSchema>;

export const GetMyDevicesResponseSchema = z.object({
  data: z.array(MyDeviceSchema),
  meta: z.object({ fileGroups: z.array(DeviceFileGroupSchema) }),
});

export const getMyDevices = defineEndpoint({
  method: 'GET',
  path: '/v1/devices/mine',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: GetMyDevicesResponseSchema,
});
